export default __webpack_public_path__ + "static/media/OECSLogo.b66b879f.png";